namespace RioERP.Reports {
    export interface OrderShippingReportRow {
        Id?: number;
        OrderId?: number;
        OrderNumber?: string;
        OrderDate?: string;
        CustomerName?: string;
        ProductName?: string;
        ProductSpecificationName?: string;
        SourceType?: number;
        BookStatus?: number;
        HasBooks?: boolean;
    }

    export namespace OrderShippingReportRow {
        export const idProperty = 'Id';
        export const nameProperty = 'OrderNumber';
        export const localTextPrefix = 'Reports.OrderShippingReport';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            OrderId = "OrderId",
            OrderNumber = "OrderNumber",
            OrderDate = "OrderDate",
            CustomerName = "CustomerName",
            ProductName = "ProductName",
            ProductSpecificationName = "ProductSpecificationName",
            SourceType = "SourceType",
            BookStatus = "BookStatus",
            HasBooks = "HasBooks"
        }
    }
}
